module.exports = __webpack_public_path__ + "img/login5.b8d6eabe.png";